/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/dialogs/alternativ-artikel-suche/shop.dialogs.alternativ-artikel-suche.component.ts.
 */
import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Artikel} from '../../../../models/artikel';
import {ArtikelKlassifizierungTyp} from '../../../../models/artikel-klassifizierung-typ';
import {BehaviorSubject, Subject} from 'rxjs';
import {AppArticleService} from '../../../../services/app.article.service';
import {takeUntil} from 'rxjs/operators';
import {AppMobileService} from '../../../../services/app.mobile.service';
import {ArtikelWithAktionen} from '../../../../models/artikel-with-aktionen';
import {AppSettingsService} from '../../../../services/app.app_settings.service';
import {ShopViewInterface} from '../../interfaces/shop.view-interface';
import {View} from '../../../../models/view';
import {ShopViewActionComponent} from '../../components/view-action/shop.view-action.component';
import {ArtikelAktion} from '../../../../models/artikel-aktion';

/**
 * Zweck: Beschreibt class ShopDialogsAlternativArtikelSucheComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.dialogs.alternativ-artikel-suche.component.html',
    styleUrls: ['shop.dialogs.alternativ-artikel-suche.component.scss'],
    standalone: false
})
export class ShopDialogsAlternativArtikelSucheComponent implements ShopViewInterface, OnInit, OnDestroy {

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(@Inject(MAT_DIALOG_DATA) public data: {artikel: Artikel, view: View, wantedAmount: number}, private svc: AppArticleService,
              private msvc: AppMobileService, private settsvc: AppSettingsService,
              private ref: MatDialogRef<ShopDialogsAlternativArtikelSucheComponent>) {
  }
  klassifizierungen = new BehaviorSubject<ArtikelKlassifizierungTyp[]>(null);
  klassifizierung: string;

  onlyOnStock = true;

  page = 1;
  limit = 20;

  total_count = new BehaviorSubject(0);

  pageSizes = [5, 10, 15, 20, 25, 50];

  entries = new BehaviorSubject<Artikel[]>(null);
  loading$ = new BehaviorSubject(false);

  isMobile = new BehaviorSubject(false);

  _destroy = new Subject();

  layout = new BehaviorSubject<string>('table');
  layoutMobile = new BehaviorSubject<string>('box');

  visible_artikel_aktionen = new BehaviorSubject<any>({});
  visible_artikel_einkaufsstatistik = new BehaviorSubject<any>({});

  fsize: string;


  actioncomps: ShopViewActionComponent[] = [];

  showAktionenDefault = false;
  showEinkaufsstatitikWebDefault = false;

  show_warning = new BehaviorSubject(false);

/**
 * Beschreibt Methode setBoxLayout und ihren Rückgabevertrag.
 */
  setBoxLayout() {
    if (this.isMobile.value) {
      this.layoutMobile.next('box');
    } else {
      this.layout.next('box');
    }
  }

/**
 * Beschreibt Methode setTableLayout und ihren Rückgabevertrag.
 */
  setTableLayout() {
    if (this.isMobile.value) {
      this.layoutMobile.next('table');
    } else {
      this.layout.next('table');
    }
  }

/**
 * Beschreibt Methode getKlassifizierungLabel und ihren Rückgabevertrag.
 */
  getKlassifizierungLabel() {
    let label = '';
    this.klassifizierungen.value.some(t => {
      if (t.id == this.klassifizierung) {
        label = t.label;
        return true;
      } else {
        return false;
      }
    });
    return label;
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load() {
    this.loading$.next(true);
    this.svc.findAlternativprodukte(this.data.artikel, this.klassifizierung, this.onlyOnStock, this.page, this.limit).subscribe(
      resp => {
        this.total_count.next(resp.count);
        this.entries.next(resp.data);
        this.loading$.next(false);
      }
    );
  }

/**
 * Beschreibt Methode doPage und ihren Rückgabevertrag.
 */
  doPage(ev) {
    this.page = ev.pageIndex + 1;
    this.limit = ev.pageSize;
    this.load();
  }

/**
 * Beschreibt Methode search und ihren Rückgabevertrag.
 */
  search() {
    this.page = 1;
    this.load();
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit() {
    this.settsvc.getUserSettingValue('ShopOpenAktionenPerDefault').subscribe({next: (state) => {
        if (state) {
          this.showAktionenDefault = true;
        }
      },
      error: (err) => {

      }
    });

    this.settsvc.getUserSettingValue('ShopOpenEKStatWebPerDefault').subscribe({next: (state) => {
        if (state) {
          this.showEinkaufsstatitikWebDefault = true;
        }
      },
      error: (err) => {

      }
    });

    this.loading$.next(true);
    this.msvc.isMobile().pipe(takeUntil(this._destroy)).subscribe(m => {
      if (this.isMobile.value != m) {
        this.isMobile.next(m);
      }
    });
    this.svc.getDefaultKlassifizierungstyp().subscribe(defaultValue => {
      this.klassifizierung = defaultValue;
      this.load();
    });
    this.settsvc.getUserSettingValue('ShopViewArticleFontSize').subscribe(s => {
      switch (s) {
        case 1:
          this.fsize = 'font-size-1';
          break;
        case 2:
          this.fsize = 'font-size-2';
          break;
        case 3:
          this.fsize = 'font-size-3';
          break;
        case 4:
          this.fsize = 'font-size-4';
          break;
        case 5:
          this.fsize = 'font-size-5';
          break;
        default:
          this.fsize = 'font-size-1';
      }
    });
    this.svc.getKlassifizierungstypen().subscribe(typen => this.klassifizierungen.next(typen));
  }

/**
 * Beschreibt Methode close und ihren Rückgabevertrag.
 */
  close() {
    this.ref.close();
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this._destroy.next(true);
    this._destroy.complete();
  }

/**
 * Beschreibt Methode focusNextMenge und ihren Rückgabevertrag.
 */
  focusNextMenge(called_elem) {
    const idx = this.actioncomps.indexOf(called_elem);
    if (this.actioncomps[idx + 1]) {
      this.actioncomps[idx + 1].focusMenge();
    }
  }

/**
 * Beschreibt Methode registerViewActionComponent und ihren Rückgabevertrag.
 */
  registerViewActionComponent(comp: ShopViewActionComponent) {
    this.actioncomps.push(comp);
    comp.entry.menge = this.data.wantedAmount;
  }

/**
 * Beschreibt Methode unregisterViewActionComponent und ihren Rückgabevertrag.
 */
  unregisterViewActionComponent(comp: ShopViewActionComponent) {
    const idx = this.actioncomps.indexOf(comp);
    this.actioncomps.splice(idx, 1);
  }

/**
 * Beschreibt Methode showWarning und ihren Rückgabevertrag.
 */
  showWarning(state: boolean) {
    this.show_warning.next(state);
  }
/**
 * Beschreibt Methode showEinkaufsStatistikWeb und ihren Rückgabevertrag.
 */
  showEinkaufsStatistikWeb(artikel: Artikel) {
    const statRegistry = this.visible_artikel_einkaufsstatistik.value;
    statRegistry[artikel.Artikelstamm + artikel.ArtikelNummer] = artikel.EinkaufsStatistikWeb;
    this.visible_artikel_einkaufsstatistik.next(statRegistry);
  }


/**
 * Beschreibt Methode hideEinkaufsStatistikWeb und ihren Rückgabevertrag.
 */
  hideEinkaufsStatistikWeb(artikel: Artikel) {
    const statRegistry = this.visible_artikel_einkaufsstatistik.value;
    delete statRegistry[artikel.Artikelstamm + artikel.ArtikelNummer];
    this.visible_artikel_einkaufsstatistik.next(statRegistry);
  }

/**
 * Beschreibt Methode showAktion und ihren Rückgabevertrag.
 */
  showAktion(artikel: Artikel, aktionen: ArtikelAktion[]) {
    const a = new ArtikelWithAktionen();
    a.artikel = artikel;
    a.aktionen = aktionen;
    const aktionenRegistry = this.visible_artikel_aktionen.value;
    aktionenRegistry[artikel.Artikelstamm + artikel.ArtikelNummer] = a;
    this.visible_artikel_aktionen.next(aktionenRegistry);
  }

/**
 * Beschreibt Methode hideAktionen und ihren Rückgabevertrag.
 */
  hideAktionen(artikel: Artikel) {
    const aktionenRegistry = this.visible_artikel_aktionen.value;
    delete aktionenRegistry[artikel.Artikelstamm + artikel.ArtikelNummer];
    this.visible_artikel_aktionen.next(aktionenRegistry);
  }
}
